export default{
  baseUrl: process.env.NODE_ENV === 'production' ? location.origin : "http://localhost:5001",
  staticImageUrl: process.env.NODE_ENV === 'production' ? location.origin : "http://localhost:8081",
}